import { I18n } from '@app/i18n/strings-keys';

export enum ORDER_STATUS_VALUE {
  New = 'new',
  Open = 'open',
  Pending = 'pending',
  Canceled = 'canceled',
  Completed = 'completed',
  Rejected = 'rejected',
}

export const ORDER_STATUS_ENUM_OPTIONS = Object.freeze({
  [ORDER_STATUS_VALUE.New]: I18n.Status.New,
  [ORDER_STATUS_VALUE.Open]: I18n.Status.Open,
  [ORDER_STATUS_VALUE.Pending]: I18n.Status.Pending,
  [ORDER_STATUS_VALUE.Canceled]: I18n.Status.Canceled,
  [ORDER_STATUS_VALUE.Completed]: I18n.Status.Completed,
  [ORDER_STATUS_VALUE.Rejected]: I18n.Status.Rejected,
});

export const ORDER_FILTER_STATUS_OPTIONS = [
  { text: I18n.Status.Open, value: ORDER_STATUS_VALUE.Open },
  {
    text: I18n.Status.Pending,
    value: ORDER_STATUS_VALUE.Pending,
  },
  {
    text: I18n.Status.Completed,
    value: ORDER_STATUS_VALUE.Completed,
  },
  {
    text: I18n.Status.Canceled,
    value: ORDER_STATUS_VALUE.Canceled,
  },
  {
    text: I18n.Status.Rejected,
    value: ORDER_STATUS_VALUE.Rejected,
  },
];
